import React from 'react';
import AuthService from '../../../services/auth.service';
import { Redirect } from 'react-router-dom';

const Logout = () => {
    AuthService().logout();
    return <Redirect to="/" />
}

export default Logout;